// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarHeader-module__Container__lSaTo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: var(--ds-size-9x);
}

.CalendarHeader-module__MonthYearLabel__Hu68g {
    color: var(--ds-calendar-header-text-color);
    /* stylelint-disable-next-line property-disallowed-list -- DS */
    font-weight: var(--ds-font-weight-medium);
    /* stylelint-disable-next-line property-disallowed-list -- DS */
    font-size: var(--ds-calendar-header-font-size);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `CalendarHeader-module__Container__lSaTo`,
	"MonthYearLabel": `CalendarHeader-module__MonthYearLabel__Hu68g`
};
export default ___CSS_LOADER_EXPORT___;
